import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './utils/axiosSetup';
import App from './App';
import { Provider } from 'react-redux';
import store from "./redux/store/index";

import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import packageJson from '../package.json';

import { bootstrap, getLandNotificationConfig, getLandNotificationCodeDescriptionConfig, getServerProductVersions } from './redux/actions/helperActions'

// This MUST come first.
bootstrap( function() {
    console.log('bootstrap complete for homepage [' + (packageJson.homepage ? packageJson.homepage : '') +
        '] version [' + packageJson.version + ']');
    
    store.dispatch(getLandNotificationConfig());
    store.dispatch(getLandNotificationCodeDescriptionConfig());
    store.dispatch(getServerProductVersions());
    
    ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
    
    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
});

